<template>

	<div>

	    <!-- show loading indicator -->
		<loading-indicator :loading="isLoading"></loading-indicator>


	    <template v-if="!isLoading">

	        <!-- page-heading -->
	        <page-heading :show="true" :pageTitle="'Newsletter ('+newsletter.name+')'"></page-heading>

			<div class="columns">

	            <div class="col-main box">

					<div class="centered">

						<div class="boxed">

							<form-input label="COMPLAT-NEWSLETTER-TITLE" :showLabel="true" inputType="text" v-model="newsletter.name" :is-horizontal="false" :isReadOnly="isReadOnly"></form-input>
							<form-input label="COMPLAT-NEWSLETTER-CHANNEL" :showLabel="true" inputType="select" selectFieldName="name" :showLabelInOptions="false" :selectOptions="newsletterTypes" v-model="newsletter.channel" :is-horizontal="false" :selectIsDisabled="isReadOnly"></form-input>
							<form-input v-if="newsletter.channel.data.editTitle" label="COMPLAT-NEWSLETTER-CUSTOM-TITLE" :showLabel="true" inputType="text" v-model="newsletter.title" :is-horizontal="false" :isReadOnly="isReadOnly"></form-input>
							<form-input label="COMPLAT-NEWSLETTER-SUBTITLE" :showLabel="true" inputType="text" v-model="newsletter.subtitle" :is-horizontal="false" :isReadOnly="isReadOnly"></form-input>
							<form-input label="COMPLAT-NEWSLETTER-SUBJECT" :showLabel="true" inputType="text" v-model="newsletter.subject" :is-horizontal="false" :isReadOnly="isReadOnly"></form-input>

							<div class="control">
								<div class="control-label">
									<label-name labelKey="COMPLAT-NEWSLETTER-SCHEDULDE_DATE"></label-name>
								</div>
								<div class="control">
									<datepicker placeholder="Datum wählen" :options="datePickerOptions" :class="{'is-disabled': isReadOnly }" v-model="newsletter.scheduleDate" ></datepicker>
								</div>
							</div>
						</div>
					</div>

					<div class="hrDivider"></div>

					<div class="centered">

						<form-input label="COMPLAT-NEWSLETTER-HEADLINE" :showLabel="true" inputType="text" v-model="newsletter.headline" :is-horizontal="false" :isReadOnly="isReadOnly"></form-input>
						<form-input label="COMPLAT-NEWSLETTER-TEXT" :showLabel="true" inputType="textarea" :textareaAutosize="true" v-model="newsletter.content" :is-horizontal="false" :isReadOnly="isReadOnly"></form-input>

						<div class="control">
							<div class="control-label">
								<label-name labelKey="COMPLAT-NEWSLETTER-KEY_VISUAL"></label-name>
							</div>
							<div class="control">

								<div :class="['keyVisual', { 'is-disabled': newsletter.channel.keyVisual !=null || isReadOnly }]" @click="imagePoolOpen">

									<!-- if there is a channel key visual present - show it - readonly -->
									<template v-if="newsletter.channel.keyVisual != null">

										<div v-lazy:background-image="getAsset(newsletter.channel.keyVisual)" class="imgWrapper lazy-img-fadein" :key="newsletter.channel.keyVisual">

										</div>

									</template>

									<template v-else>

										<template v-if="newsletter.keyVisual != null">

											<div v-lazy:background-image="getAsset(newsletter.keyVisual)" class="imgWrapper lazy-img-fadein" :key="newsletter.keyVisual">
												<pop-confirm class="icon is-small imageRemove" content="Möchten Sie dieses Bild wirklich entfernen?" cancel-text="nein" ok-text="ja" :on-ok="function() { newsletter.keyVisual = null; }">
													<i class="icon-ak-entfernen" title="Bild entfernen"></i>
												</pop-confirm>
											</div>

										</template>

										<template v-else>

											<div class="notice has-text-centered">
												<span class="icon is-large is-light"><i class="fa fa-cloud-upload"></i></span><br />
												Klick um Bilder-Pool zu öffnen
											</div>

										</template>

									</template>

								</div>

							</div>
						</div>


						<form-input label="COMPLAT-NEWSLETTER-INTROTEXT" :showLabel="true" inputType="textarea" :textareaAutosize="true" v-model="newsletter.introText" :is-horizontal="false" :isReadOnly="isReadOnly"></form-input>

						<div class="control" v-if="!newsletter.channel.data.newsletterSender">
							<div class="control-label">
								<label-name labelKey="COMPLAT-NEWSLETTER-SENDER"></label-name>
							</div>
							<div class="control">

								<multiselect
									v-model="newsletter.sender"
									placeholder="Bitte Absender wählen"
									label="title"
									track-by="id"
									:disabled="isReadOnly"
									:options="newsletterSender"
									:option-height="104"
									:show-labels="false">

									<template slot="singleLabel" slot-scope="props">
										<div class="option__image imgWrapper lazy-img-fadein" v-lazy:background-image="getAsset(props.option.asset)" :key="props.option.id"></div>
										<span class="option__desc">
											<span class="option__title">{{ props.option.name }}</span><br />
											<span class="option__small">{{ props.option.role }}</span>
										</span>
									</template>

									<template slot="option" slot-scope="props">
										<div class="option__image imgWrapper lazy-img-fadein" v-lazy:background-image="getAsset(props.option.asset)" :key="props.option.id"></div>
										<div class="option__desc">
											<span class="option__title">{{ props.option.name }}</span><br />
											<span class="option__small">{{ props.option.role }}</span>
										</div>
									</template>

								</multiselect>

							</div>


						</div>

					</div>

					<div class="hrDivider"></div>

					<div class="centered">

						<template v-if="newsletter.elements.length > 0">

							<div class="newsletterArticles">

								<draggable
									:list="newsletter.elements"
									:options="{
										animation: 200,
										handle: '.dragHandler',
										draggable: '.list-complete-item',
									}"
									@end="onDragComplete()">

									<div v-for="(el, index) in newsletter.elements" :class="['columns newsletterArticle list-complete-item', { 'is-disabled': isReadOnly }]" :key="el">

										<template v-if="el.articleVariant != null && el.articleVariant.article != null">

											<div class="column is-narrow">
												<div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getAsset(el.articleVariant.teaserImage)" :key="el.articleVariant.article.id"></div>
											</div>

											<div class="column" :key="el.articleVariant">
												<div class="preview">
													<span class="headline">{{ el.articleVariant.headline }}</span>
													<div v-html="getExcerpt(el.articleVariant, 500)"></div>

													<template v-if="!isVariantPublished(el.articleVariant)">
														<span class="attention">Achtung: Dieser Beitrag wurde noch nicht publiziert!</span>
													</template>

												</div>
											</div>

										</template>

										<template v-else>

											<div class="column froalaPlain">
												<froala :id="'froala'+index" :tag="'textarea'" :config="froalaConfig" v-model="el.content"></froala>
											</div>

										</template>


										<div class="column is-narrow">

											<span class="icon is-small dragHandler has-cursor-move" title="Beitrag verschieben">
												<i class="icon-ak-move"></i>
											</span>

											<pop-confirm :class="['icon is-small has-pointer delArticle']" content="Möchten Sie diesen Beitrag wirklich entfernen?" icon="question-circle-o" cancel-text="nein" :on-ok="function() { newsletterArticleRemove(index) }">
												<i class="fa icon-ak-entfernen" title="Beitrag löschen"></i>
											</pop-confirm>

										</div>

									</div>

								</draggable>

							</div>
						</template>

						<div class="contentAddButtons">

							<span :class="['button', {'is-loading': articlesLoading }, {'is-disabled': isReadOnly || (newsletter.channel != null && !newsletter.channel.data.articleVariantType) || newsletter.elements.length > maxArticles }]" @click="addTeaser">
								<lang labelKey="COMPLAT-NEWSLETTER-ADD_TEASER"></lang>
								<span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span>
							</span>
							<span :class="['button', {'is-disabled': isReadOnly || newsletter.elements.length > maxArticles }]" @click="addContent">
								<lang labelKey="COMPLAT-NEWSLETTER-ADD_CONTENT"></lang>
								<span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span>
							</span>

						</div>

					</div>

				</div>

                <div class="col-aside">
					<custom-button type="blue" name="COMPLAT-NEWSLETTER-BTN-NEWSLETTER_SAVE" icon="icon-ak-speichern" :loading="isSaving" @click.native="newsletterSave(false, true)" :class="{ 'is-disabled': isReadOnly }"></custom-button>
					<custom-button type="blue" name="COMPLAT-NEWSLETTER-BTN-NEWSLETTER_SEND" icon="icon-ak-send" :loading="isSending" @click.native="openModal(false)" :class="{ 'is-disabled': isReadOnly }"></custom-button>
					<custom-button type="blue" name="COMPLAT-NEWSLETTER-BTN-NEWSLETTER_SEND_TEST" icon="icon-ak-send" :loading="isSendingTest" @click.native="openModal(true)" :class="{ 'is-disabled': isReadOnly }"></custom-button>
                </div>

            </div> <!-- // columns -->


        </template>


		<image-pool :articleId="null" :assets="[]" :show="showImagePool" @close="showImagePool=false" @selectImage="selectImagePoolImage"></image-pool>



        <!-- MODAL -->
		<modal
			:width="modal.width"
			:title="modal.title"
			transition="fadeDown"
			cancel-text="Abbrechen"
			:show-ok="false"
			:backdrop-closable="false"
			:is-show="showModal"
			:class="modal.type"
			@close="closeModal">

				<template v-if="modal.isLoading">

					<loading-indicator></loading-indicator>

				</template>

				<template v-else>

					<!-- ARTICLES -->
					<template v-if="modal.type == 'contentPool'">

						<v-client-table ref="tblNewsletterArticles" name="tblNewsletterArticles" :data="articles" :columns="tblArticles.columns" :options="tblArticles.options" class="noFirstColumn">

							<!-- before table: FILTER OPTIONS -->
							<template slot="beforeTable">

								<!-- search -->
								<div class="control has-icon search is-pulled-left">
									<input class="input" type="text" v-model="articleSearchString" placeholder="Suchbegriff">
									<i class="fa fa-search" aria-hidden="true"></i>
								</div>

							</template>

							<!-- checkbox -->
							<template slot="select" slot-scope="props">
								<div class="checkboxWrapper">
									<p-check name="check" color="primary" :value="props.row.id" v-model="markedRows" class="p-default p-curve p-smooth"></p-check>
								</div>
							</template>

							<!-- image -->
							<template slot="asset" slot-scope="props">
								<div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getAsset(props.row.teaserImage)" :key="props.row.id"></div>
							</template>

							<!-- name -->
							<template slot="headline" slot-scope="props">
								{{ props.row.headline }}
							</template>

							<!-- title intern -->
							<template slot="title" slot-scope="props">
								<template v-if="props.row.article != null">
									{{ props.row.article.title }}
								</template>
							</template>

						</v-client-table>

						<div slot="footer">
							<span class="button" @click="closeModal">schließen</span>
							<span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': markedRows.length == 0 || markedRows.length > maxArticles }]" @click="newsletterAppendArticles">übernehmen</span>
						</div>

					</template>

					<!-- NEWSLETTER -->
					<template v-else-if="modal.type == 'newsletter'">

						<template v-if="progressStatus == null">

							<p>Sind Sie sicher, dass Sie den Newsletter an den hinterlegten Verteilerkreis senden wollen?</p>

							<div slot="footer">
								<span class="button" @click="closeModal">abbrechen</span>
								<span :class="[{'is-loading': isSending }, 'button is-success']" @click="newsletterSendStart(false)">senden</span>
							</div>

						</template>

						<template v-else>

							<template v-if="progressStatus.status != 'Finished'">

								<template v-if="progressStatus.status == 'Error'">

									<div class="has-text-centered" style="margin-bottom: 5px;">
										Der Newsletter konnte nicht versendet werden:<br />
										<span style="color: red; ">{{ progressStatus.log }}</span>
									</div>

								</template>

								<template v-else>

									<div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
									<progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

								</template>

							</template>

							<template v-else>

								<div class="has-text-centered">Email wurde erfolgreich versandt!</div>

							</template>

						</template>

					</template>


					<!-- TEST NEWSLETTER -->
					<template v-else-if="modal.type == 'newsletterTest'">

						<template v-if="progressStatus == null">

							<form-input inputType="text" v-model="testRecipient" placeholder="max@mustermann.at"></form-input>

							<div slot="footer">
								<span class="button" @click="closeModal">abbrechen</span>
								<span :class="['button is-success', { 'is-loading': isSending }]" @click="newsletterSendStart(true)">senden</span>
							</div>

						</template>

						<template v-else>

							<template v-if="progressStatus.status != 'Finished'">

								<template v-if="progressStatus.status == 'Error'">

									<div class="has-text-centered" style="margin-bottom: 5px;">
										Der Newsletter konnte nicht versendet werden:<br />
										<span style="color: red; ">{{ progressStatus.log }}</span>
									</div>

								</template>

								<template v-else>

									<div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
									<progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

								</template>

							</template>

							<template v-else>

								<div class="has-text-centered">Test Email erfolgreich versandt!</div>

							</template>

						</template>

					</template>

					<!-- IMAGE RESIZE -->
					<template v-else-if="modal.type == 'imageCrop'">

						<croppa
							v-model="imageCropData"
							:width="imageCropWidth"
							:height="imageCropHeight"
							:disable-click-to-choose="true"
							:disable-drag-to-move="false"
							:disable-drag-and-drop="true"
							:disable-pinch-to-zoom="true"
							:disable-rotation="true"
							:show-remove-button="false"
							:prevent-white-space="true"
							:key="imageCropImage"
							:initial-image="imageCropImage"
							@init="cropInit">
							<!-- :initial-image="imageCropImage"> -->
								<!-- <img crossOrigin="anonymous" :src="imageCropImage" slot="initial"> -->
						</croppa>

						<div slot="footer">
							<span class="button" @click="closeModal">abbrechen</span>
							<span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="appendCroppedImage">übernehmen</span>
						</div>

					</template>

				</template>

		</modal>

    </div>

</template>




<script>
import Multiselect from 'vue-multiselect';
import imagePool from '../contentPool/incl-imagePool';

import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import { de } from 'flatpickr/dist/l10n/de';

import draggable from 'vuedraggable';

// https://lokesh-coder.github.io/pretty-checkbox/
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala);

import vue2Dropzone from '../../utils/dropzoneWrapper';

import 'vue-croppa/dist/vue-croppa.css';
import Croppa from 'vue-croppa'
Vue.use(Croppa);

export default {

    name: 'complatNewsletter',

	components: {
		VueFroala,
		Multiselect,
		imagePool,
		draggable,
		vueDropzone: vue2Dropzone,
    },

    data() {

        return {
			isSaving: false,
			isSending: false,
			// isSendingTest: false,
            isLoading: false,

			newsletter: {},
			newsletterSender: null,
			showImagePool: false,

			maxArticles: 100,
			markedRows: [],
			newsletterTypes: [],
			articles: [],
			articleSearchString: "",
			articlesLoading: false,

			currentImage: null,
			imagePoolIsSingleImage: true,
			imageCropWidth: 690,
			imageCropHeight: 250,
			imageCropImage: null,
			imageCropData: {},

			refreshIntervalId: null,
			progressStatus: null,

			showModal: false,
			modal: {
				isLoading: false,
				isSaving: false,
				width: '640',
				type: '',
				class: '',
				title: ''
			},

			datePickerOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
				clickOpens: true,
                weekNumbers: true
            },

			froalaConfig: {
                key: '',
				// 'insertImage',
                toolbarButtons: ['bold', 'italic', 'underline', 'h1', '|', 'insertLink', '|', 'subscript', 'superscript', '|', 'align', '|', 'customImageButton', '|', 'undo', 'redo'],
                placeholderText: 'Schreiben Sie hier Ihren Text ...',
				wordPasteModal: false,
				pastePlain: true,
                initOnClick: false,
				heightMin: 300,
				// heightMax: 500,

                imageManagerLoadURL: '',
                imageUploadURL: '',
                imageUploadParams: { froala: 1 },
				imageInsertButtons: ['imageUpload'],

				imageEditButtons: ['imageAlign', 'imageCaption', 'imageRemove', '-', 'imageDisplay', 'imageAlt', 'imageSize'],

                // quickInsertButtons: ['table', 'ul', 'ol'],
				quickInsertButtons: [],
                quickInsertTags: [],
                language: 'de',
	            tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
                tableMultipleStyles: false,
                tableResizer: true,
				charCounterCount: false,
				// charCounterMax: 140,
                // quickInsertTags: [],        // disable quickInsertBar
            },

			tblArticles: {
				columns: ['select', 'asset', 'headline', 'title'],
				options: {
					trackBy: 'id',
					uniqueKey: 'id',
					saveState: false,
					perPage: 5,

					// custom table headings
					headings: {

						select(h) {
                            return "";
                        },
                        asset(h) {
                            return <lang labelKey="NEWSLETTER-ARTICLES-TBL_HEADER-ASSET"></lang>
                        },
						headline(h) {
							return <lang labelKey="NEWSLETTER-TBL_HEADER-NAME"></lang>
						},
						title(h) {
							return <lang labelKey="NEWSLETTER-TBL_HEADER-TITLE"></lang>
						}
					},

					columnsClasses: { 'edit': 'edit' },

					sortable: ['title'],
					sortIcon: {
						base:'fa',
						up:'fa-sort-up',
						down:'fa-sort-down',
						is:'fa-sort'
					},
					filterByColumn: false,
					filterable: false,

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

					skin: 'table is-striped is-hoverable is-fullwidth',

					// custom filter functions
                    customFilters: [
                        {
                        name: 'search',
    						callback(row, string) {

    							if(string == null || string == "") {
    								return true;
    							}

    							string = string.toLowerCase();
    							return row.headline.toLowerCase().indexOf(string) > -1 || (row.article != null && row.article.title.toLowerCase().indexOf(string) > -1);

    						}
                        }

                    ],
				}
			},

        }

    },

	watch: {

		articleSearchString(newVal, oldVal) {

			if(newVal == oldVal) {
				return;
			}
			var self = this;

			setTimeout(function() {
				Event.$emit('vue-tables.tblNewsletterArticles.filter::search', newVal);
			}, 10);

		},

		markedRows(newVal, oldVal) {

			if(this.markedRows.length > this.maxArticles) {
				this.$notify.open( { content: 'Sie können nur maximal '+this.maxArticles+' Artikel auswählen', type: 'warning' })
			}

		},

		'newsletter.channel'(newVal) {

			if(!newVal || newVal == null) {
				return;
			}

			let type = newVal.name;
			let subtitle = "";

			switch(type) {

				case 'Newsletter BeiratsNews':
					subtitle = "Exklusive Informationen für Beiräte der Herba Chemosan";
					break;

				case 'Newsletter ManufacturerNews':
					subtitle = "Exklusive Informationen für Industriepartner der Herba Chemosan Gruppe";
					break;

				case 'Newsletter ErfolgsNews':
					subtitle = "Erfolgsnachrichten aus der Herba-Gruppe";
					break;

				case 'Newsletter pharma.dialog':
					subtitle = "Informationen aus der Herba für Studierende und JungpharmazeutInnen";
					break;

				case 'Newsletter ChefInfo':
					subtitle = "";
					break;

				default:
					subtitle = "";

			}

			this.newsletter.subtitle = subtitle;

		}

	},

	computed: {

		isReadOnly() {
			return this.newsletter.status && this.newsletter.status.name == 'SENT';
		}

	},

    created() {

		// set licence key for froala
		this.froalaConfig.key = this.$config.froalaKey;

		var self = this;

		// initialize custom button for froala RTE
	    $.FroalaEditor.DefineIcon('customImageButton', { NAME: 'image'});

	    $.FroalaEditor.RegisterCommand('customImageButton', {
	        title: 'neues Bild einfügen',
	        focus: false,
	        undo: true,
	        refreshAfterCallback: false,
	        callback: function () {
				self.currentEditorId = $( $(this.el).parents('.column').find('textarea')[0] ).attr("id");
				this.selection.save();			// save current cursor selection
				self.imagePoolOpen('froala');	// open image pool modal
	        }
	    });


		$.FroalaEditor.DefineIcon('h1', { NAME: 'H1', template: 'text'} );
		$.FroalaEditor.RegisterCommand('h1', {
			title: 'Überschrift',
			focus: true,
	        undo: true,
	        refreshAfterCallback: true,
			callback: function (cmd, val, params) {
				if (isActive.apply(this, [cmd])) {
					this.format.remove('h1', { class: 'headline' });
					this.paragraphFormat.apply('N');
				}
				else {
					this.paragraphFormat.apply(cmd);
					this.paragraphStyle.apply('headline');
				}
			},
			refresh: function ($btn) {
				$btn.toggleClass('fr-active', isActive.apply(this, [$btn.data('cmd')]));
			}
		});


		// Define a button.
	    $.FroalaEditor.RegisterQuickInsertButton('customImageButton', {
			icon: 'customImageButton',
			title: 'neues Bild einfügen',
	        focus: false,
	        undo: true,
	        refreshAfterCallback: false,
	        callback: function () {
				self.currentEditorId = $( $(this.el).parents('.column').find('textarea')[0] ).attr("id");
				this.selection.save();			// save current cursor selection
				self.imagePoolOpen('froala');	// open image pool modal
	        }
	    })

		var isActive = function (cmd) {

			var blocks = this.selection.blocks();

			if (blocks.length) {
				var blk = blocks[0];
				var tag = 'N';
				var default_tag = this.html.defaultTag();
				if (blk.tagName.toLowerCase() != default_tag && blk != this.el) {
					tag = blk.tagName;
				}
			}

			if (['LI', 'TD', 'TH'].indexOf(tag) >= 0) {
				tag = 'N';
			}

			return tag.toLowerCase() == cmd;
		}


		if(this.$route.params.newsletterID) {
        	this.fetchData(this.$route.params.newsletterID);
		}

    },

    methods: {

		isVariantPublished(variant) {

			// console.log("variant: ", variant);

			if(typeof variant.isPublished == 'undefined') {
				return true;
			}

			return variant.isPublished;

		},

		cropInit() {

			/*
			var metaData = this.variant[this.imagePoolTarget + 'Data'];

			var self = this;
			setTimeout(function() {
				self.imageCropData.applyMetadata(metaData);
			}, 15);
			*/

		},

		appendCroppedImage() {

			this.modal.isSaving = true;

			var self = this;

			this.imageCropData.generateBlob((blob) => {

				var file = new File([blob], this.currentImage.filename, { type: 'image/jpeg', lastModified: Date.now()});
				var fd = new FormData()
				fd.append('file', file);

				self.axios.post(self.$config.api + 'fileProcessing/upload?preset=newsletter', fd)
					.then(function(response) {

						self.modal.isSaving = false;

						var croppedImage = {
							filename: response.data.fileName,
							path: response.data.dir,
							uploadFilename: self.currentImage.filename
						}

						self.newsletter.keyVisual = croppedImage;

						self.closeModal();

						self.currentImage = null;
						self.imageCropImage = null;
						self.imageCropData = {};
						self.imagePoolTarget = null;

					}).catch(function(error) {

						console.log('Error: ', error.message);
						self.modal.isSaving = false;

					});

            }, 'image/jpeg', 0.85);

		},

		imagePoolOpen(target=null) {

			this.imagePoolTarget = target;
			this.showImagePool = true;

		},

		selectImagePoolImage(images) {

			// close image pool
			this.showImagePool = false;

			// get the selected image
			var image = images[0];
			var imageUrl = this.getAsset(image.asset);

			// FROALA EDITOR
			if(this.imagePoolTarget == 'froala') {

				// generate random image id
				let imgId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);

				$('#'+this.currentEditorId).froalaEditor('selection.restore');
				$('#'+this.currentEditorId).froalaEditor('image.insert', 'https:' + imageUrl, true, { 'id': imgId, 'caption': image.asset.caption, 'alt': image.asset.altText }, null, {link: 'http://example.com/file.pdf'});

				/*
				$('#froala').froalaEditor('selection.restore');
				$('#froala').froalaEditor('image.insert', 'https:' + imageUrl, true, { 'id': imgId, 'caption': image.asset.caption, 'alt': image.asset.altText }, null, {link: 'http://example.com/file.pdf'});
				*/

				setTimeout(function() {

					// set alt attribute
					$('[data-id="'+imgId+'"]').attr('alt', image.asset.altText);

				}, 100);

				this.imagePoolTarget = null;

			} else {

				// prepare data for image cropping and show the modal
				this.currentImage = image.asset;
				this.imageCropData = {};
				this.imageCropImage = this.getAsset(image.asset);

				this.showModal = true;
				this.modal.width = 740;
				this.modal.type = "imageCrop";
				this.modal.title = "Bild Ausschnitt wählen";
			}

		},

		getExcerpt(el, maxLength=580) {

            let str = "";
            let text = el.content;

            if(text.length > maxLength) {
                text = text.substr(0, maxLength);
                str = text.substr(0, Math.min(text.length, text.lastIndexOf(" "))) + ' ...'
            } else {
                str = text;
            }

            return str + ' <a class="readmore" href="http://www.apothekenkatalog.at/'+el.friendlyName+'" target="_blank">weiterlesen</a>';
        },

		onDragComplete() {

			this.newsletter.elements.forEach((el, index) => {
				el.sortorder = index;
			})

			this.$notify.open({ content: 'Beitrag wurde erfolgreich verschoben!', type: 'success'});
		},

		addTeaser() {

			this.articlesLoading = true;
			this.modal.type = "contentPool";
			this.modal.class = "contentPool";
			this.modal.title = "Content Pool";
			this.modal.width = 860;

			this.markedRows = [];

			this.newsletter.elements.forEach((el) => {
				if(el.articleVariant != null) {
					this.markedRows.push(el.articleVariant.id);
				}
			})
			var self = this;

			this.fetchArticles()
				.then((response) => {

					self.showModal = true;
					self.articleSearchString = "";
					self.articlesLoading = false;

					Event.$on('vue-tables.tblNewsletterArticles.row-click', function(data) {

                        if(['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                            return false;
                        }

                        let foundIndex = self.markedRows.findIndex(function(row) { return row == data.row.id; });

                        if(foundIndex > -1) {

                            self.markedRows.splice(foundIndex, 1);

                        } else {

							if(self.markedRows.length >= self.maxArticles) {
								self.$notify.open( { content: 'Sie können nur maximal '+self.maxArticles+' Artikel auswählen', type: 'warning' })
								return false;
							}

                            self.markedRows.push(data.row.id);
                        }

                    });

				});

		},

		addContent() {

			var self = this;

			self.newsletter.elements.push({
				content: null,
				catalogPageElement: null,
				articleVariant: null,
				sortorder: self.newsletter.elements.length
			});

		},

		newsletterAppendArticles() {

			var self = this;
			self.modal.isSaving = true;

			// make sure we got the elements array
			if(typeof this.newsletter.elements == 'undefined') {
            	this.$set(this.newsletter, 'elements', []);
			}

			this.newsletter.elements.forEach((el, index) => {

				if(el.articleVariant != null) {

					// synchronize markedRows <-> elements
					// remove teaser item from elements array if it is not part of "markedRows" anymore ..
					if(self.markedRows.indexOf(el.articleVariant.id) == -1) {
						self.newsletter.elements.splice(index, 1);
					} else {
						self.markedRows.splice(self.markedRows.indexOf(el.articleVariant.id), 1);
					}
				}

			});


			// fetch all selected articles and push it into the elements array of the newsletter
			this.markedRows.forEach(function(rowId) {

				self.newsletter.elements.push({
					content: null,
					catalogPageElement: null,
					articleVariant: self.articles.find(function(article) { return article.id == rowId }),
					sortorder: self.newsletter.elements.length
				});

			});

			//self.modal.isSaving = false;
			//self.closeModal();

			let url = 'newsletter/'+self.newsletter.id+'?include=newsletter.channel,newsletter.elements,newsletter.status,newsletterElement.articleVariant,articleVariant.article,newsletter.sender,newsletterSender.asset,articleVariant.teaserImage,newsletter.keyVisual&orderBy=newsletterElement.sortorder';

			// save/update
            this.entityCreateOrUpdate(url, self.newsletter)
                .then(function(response) {
					self.newsletter = response;
					self.modal.isSaving = false;
                    self.closeModal();
                })


		},


		newsletterArticleRemove(index) {

			// let id = this.newsletter.elements[index].articleVariant.id;
			this.newsletter.elements.splice(index, 1);

			// resort
			this.newsletter.elements.forEach((el, index) => { el.sortorder = index });

		},


		closeModal() {

			clearInterval(this.refreshIntervalId);

			Event.$off('vue-tables.tblNewsletterArticles.row-click');

			this.showModal = false;
			this.testRecipient = null;
			this.progressStatus = null;
			this.refreshIntervalId = null;
			this.isSending = false;

			// this.articleSearchString = "";

			this.modal = {
				isLoading: false,
				isSaving: false,
				width: 640,
				type: '',
				class: '',
				title: ''
			};

		},


		getAsset(asset, thumb=false) {

			if(asset == null) {
				return "";
			}

			return this.$config.assets + asset.path + '/' + (thumb == true ? 'thumb/' : '' ) + asset.filename;

		},

		newsletterSave(isSilent=false, updateUpdatedField=false) {

			this.isSaving = true;
			var self = this;

			if(updateUpdatedField) {
				// set the "updatedAt" field to the current time
				var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
				self.newsletter.updatedAt = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
			}

			if(self.newsletter.channel.keyVisual != null) {

				self.newsletter.keyVisual = self.newsletter.channel.keyVisual;

			}

			// save
			return new Promise(function(resolve, reject) {
				self.entityCreateOrUpdate('newsletter', self.newsletter, { isSilent: isSilent })
					.then((response) => {
						resolve();
					})
			});

		},

		openModal(isTestNewsletter=false) {

			if(isTestNewsletter===true) {
				this.modal.title = "Testnewsletter versenden";
				this.modal.type = "newsletterTest";
			} else {
				this.modal.title = "Newsletter versenden";
				this.modal.type = "newsletter";
			}

			this.modal.class = "newsletter";
			this.modal.width = 480;

			this.showModal = true;

		},


		newsletterSendStart(isTest=false) {

			this.isSending = true;

			if(isTest && !this.validateEmail(this.testRecipient)) {
				this.$notify.open({ content: 'Bitte geben Sie eine gültige E-Mail Adresse ein!', type: 'warning' })
				this.modal.isSaving = false;
				this.isSending = false;
				return;
			}

			this._newsletterSend(isTest);

		},


		_newsletterSend(isTest=false) {

			var self = this;

			this.newsletterSave(true)
				.then((response) => {

					let url = self.$config.api + 'newsletter/send?newsletter='+self.newsletter.id;
					if(isTest && self.testRecipient != null) {
						url += '&testRecipient='+self.testRecipient
					}

					self.axios.get(url)
						.then((response) => {

							let taskLogId = response.data.taskLogId;

                            self.refreshIntervalId = setInterval(function() {

                                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                                    .then(function(response) {

                                        self.progressStatus = response.data;

										if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                                            clearInterval(self.refreshIntervalId);

											if(response.data.status == 'Finished') {
												self.$notify.open({ content: 'Newsletter wurde erfolgreich versendet!', type: 'success'})
											}

											self.isSending = false;
											self.closeModal();

										}

                                    });

                            }.bind(self), 1000);

						})

				})

		},


		dzSuccess(file, response) {

            var self = this;
            this.modal.isLoading = false;
            this.modal.isSaving = false;
            this.modal.type = 'uploadRecipients';
            this.modal.title = 'Verarbeitung';
            this.modal.width = '640';
            this.modal.class = 'uploadRecipients';

            this.showModal = true;

            this.$refs.vueDropzoneXls.$children[0].removeAllFiles();
            let taskLogId = response.taskLogId;

            self.refreshIntervalId = setInterval(function() {

                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                    .then(function(response) {

                        self.progressStatus = response.data;

                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                            clearInterval(self.refreshIntervalId);

                            self.axios.get(self.$config.api + 'newsletter/subscribers?site='+self.siteId)
                                .then(function(response) {
                                    self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                    self.recipients.data = response.data;
                                    self.closeModal();
                                })
                        }

                    });

            }.bind(self), 1000);


            setTimeout(function() {

                clearInterval(self.refreshIntervalId);
                self.showModal = false;

            }, 100000);

        },

        fetchData(newsletterID) {

			this.isLoading = true;
			var self = this;

			function newsletterSender() {
				return self.axios.get(self.$config.api + 'newsletterSender?include=newsletterSender.asset');
			}
			function newsletter() {
				return self.axios.get(self.$config.api + 'newsletter/'+newsletterID+'?include=newsletter.channel,newsletter.elements,newsletter.status,newsletterElement.articleVariant,articleVariant.article,newsletter.sender,newsletterSender.asset,articleVariant.teaserImage,newsletter.keyVisual,channel.keyVisual&orderBy=newsletterElement.sortorder');
			}
			function newsletterTypes() {
				return self.axios.get(self.$config.api + 'channel?include=channel.type,channel.keyVisual&filters[type.name]=NEWSLETTER&filters[isCommunicationPlatformNewsletter]=1&orderBy=name');
				//filters[id]=7,8,9,13,14,15,16
			}

			this.axios.all([newsletterSender(), newsletter(), newsletterTypes()])
				.then(self.axios.spread(function (newsletterSender, newsletter, types) {

					self.newsletterSender = newsletterSender.data.newsletterSender;
					self.newsletter = newsletter.data;
					self.newsletterTypes = types.data.channel;

					self.isLoading = false;


				})).catch(function(error) {
					console.log("ERROR: ", error);
				});

        },

		fetchArticles() {

			var self = this;

			return new Promise(function(resolve, reject) {

				self.axios.get(self.$config.api + 'articleVariant?filters[type]='+self.newsletter.channel.data.articleVariantType+'&include=articleVariant.article,articleVariant.teaserImage')
					.then((response) => {
						// console.log(response.data.articleVariant);
						self.articles = response.data.articleVariant;
						resolve(self.articles);
					});

			})

		},

    }

}



</script>


<style lang="scss">

	@import '~../../../assets/css/variables.scss';
    @import '~pretty-checkbox/src/pretty-checkbox.scss';
    .p-default {
        margin: 0;
    }

	.centered .boxed,
	.centered .columns.newsletterArticle,
	.contentAddButtons .button {
		transition: background-color .3s ease;
		background: $themeTblCellEvenColor;
	}
	.contentAddButtons .button:hover {
		background: $themeTblCellHoverColor;
	}
	.hrDivider {
		padding-top: 20px;
		margin-bottom: 15px;
		border-bottom: 2px solid $themeTblCellEvenColor;
	}

</style>


<style scoped>

ul.tabNav {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	list-style-type: none;
	flex: 0 1 auto;
}
ul.tabNav li.item {
	padding: 0;
	margin: 0;
	line-height: 24px;
	overflow: hidden;
}
ul.tabNav li.item a {
	padding: 13px 17px;
	border-radius: 0;
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
	text-transform: uppercase;
	color: #515159;
	border: none;
	-webkit-transition: background-color .3s ease;
	transition: background-color .3s ease;
	align-items: center;
	display: flex;
	justify-content: center;
	margin-bottom: -1px;
	vertical-align: top;
	white-space: nowrap;
	font-size: 13px;
}
ul.tabNav li.item a:hover,
ul.tabNav li.item.is-active a {
	color: #000;
	background: #fff;
	font-weight: 500;
}
ul.tabNav li.item:not(.is-active) a:hover {
	background: rgba(255,255,255,.5);
}
ul.tabNav li.is-disabled a {
	background: none !important;
	color: #cdcdd2;
	cursor: default;
}
ul.tabNav li.is-disabled a:hover {
	background: none !important;
	color: #aaa;
	font-weight: normal;
}


	/*
	.boxed >>> .control .input[readonly] {
		background-color: #f0f1f2 !important;
		border: 1px solid #e8e9ea !important;
		color: #8d99a4 !important;
	}
	*/

	.contentAddButtons {
		text-align: center;
		margin-top: 15px;
	}
	.contentAddButtons .button {
		border: none;
		border-radius: 3px;
		padding: 20px 25px;
	}

	.contentAddButtons .button .icon {
		margin-left: 8px !important;
	}

	.centered {
		max-width: 700px;
	    width: 100%;
	    margin: 0 auto;
	}
	.centered {
		max-width: 700px;
		width: 100%;
		margin: 0 auto;
	}
	.centered >>> .control {
		max-width: 100%;
	}
	.centered >>> .control > .control {
		max-width: 100%;
	}
	.centered >>> .multiselect {
		max-width: inherit;
	}

	.centered .hrLine {
	    padding-top: 6px;
        border-bottom: 4px solid #EEE;
        margin: 0 -40px 12px -40px;

    }
	.centered .boxed {
		padding: 15px 40px;
		margin-left: -40px;
		margin-right: -40px;
		margin-bottom: 15px;
		border-radius: 3px;
	}

	.multiselect >>> .multiselect__element {
		clear: both;
	}
	.multiselect >>> .multiselect__single,
	.multiselect >>> .multiselect__option {
		display: flex;
	}
	.multiselect >>> .multiselect__single .option__image,
	.multiselect >>> .multiselect__option .option__image {
		width: 70px;
		height: 50px;
		background-position: 50% 50%;
		background-size: contain;
		background-repeat: no-repeat;
		background-color: #f1f1f1;
		border: 1px solid #ddd;
		border-radius: 2px;
		margin: 0;
	}

	.multiselect >>> .multiselect__single .option__desc,
	.multiselect >>> .multiselect__option .option__desc {
		padding-left: 15px;
	}

	.multiselect >>> .option__title {
		font-size: 12px;
		font-weight: bold;
	}
	.multiselect >>> .option__small {
		font-size: 12px;
	}





	/* articles modal */
    >>> .modal-card-body {
        overflow: auto;
    }
    .contentPool >>> .modal-card {
        min-height: 640px;
        max-height: 640px;
    }
	.contentPool >>> th:first-child {
		width: 40px;
	}
	.contentPool >>> th:nth-child(2) {
		width: 90px;
	}
	.contentPool >>> td {
		padding-top: 7px;
		padding-bottom: 7px;
	}

	.contentPool >>> td:first-child {
        position: relative;
        width: 40px;
    }
	.contentPool >>> td:first-child .checkboxWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0; right: 0;
        top: 0;
        bottom: 0;
        padding-left: 4px;
    }
	.contentPool >>> .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: cover;
		width: 65px;
		height: 45px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;
	}
	.contentPool >>> .imgWrapper[lazy=loading]  {
		background-size: 30% !important;
	}
	.contentPool >>> .imgWrapper[lazy=error]  {
		background-size: contain !important;
	}





	.keyVisual {
		width: 100%;
		height: 255px;
		border: 1px solid #eee;
		background: #fff;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.keyVisual .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: contain;
        width: 120px;
        height: 85px;
		margin: 0 auto;
		width: 100%;
		height: 100%;
	}
	.keyVisual .imgWrapper[lazy=loading]  {
		background-size: 10% !important;
	}

	.keyVisual .imageRemove {
		position: absolute;
		right: 5px;
		top: 5px;
		/*visibility: hidden;*/
	}
	.keyVisual:hover .imageRemove {
		visibility: visible;
	}
	.keyVisual .notice {
		color: #ddd;
		font-size: 12px;
	}


	.newsletterArticles {
        margin: 0 auto;
        width: 100%;
		margin-bottom: 5px;
    }
    >>> .columns.newsletterArticle {
        /*max-width: 100%;*/
        white-space: normal;
		padding: 10px 30px;
		/*width: 100%;*/
		border-radius: 3px;
		margin: 0 -40px 8px -40px;
    }
	/*
    >>> .columns.newsletterArticle:last-child {
        border-bottom: none !important;
        margin-bottom: 0;
    }
	*/

    >>> .columns.newsletterArticle .column {
        line-height: 1.2rem;
    }

    >>> .columns.newsletterArticle .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: cover;
        width: 120px;
        height: 85px;
        margin: 0 5px 0 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }

	>>> .columns.newsletterArticle .imgWrapper[lazy=loading] {
		background-size: 30% !important;
	}
    >>> .columns.newsletterArticle .imgWrapper[lazy=error]  {
		background-size: contain !important;
	}

    >>> .columns.newsletterArticle .column .headline {
        display: block;
        margin-top: 5px;
        margin-bottom: 10px;
        font-size: 1.2rem;
    }

	>>> .columns.newsletterArticle .column .preview a.readmore {
        background: none !important;
        display: inline !important;
        text-decoration: underline !important;
        font-weight: normal !important;
        border: none !important;
        text-transform: lowercase !important;
		padding: 0;
    }
	>>> .columns.newsletterArticle .column .preview .attention {
		color: red;
		display: block;
		margin-top: 10px;
    }
</style>
